import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { NotificationsService } from '../core/services/notifications.service';
import { environment } from '../../environments/environment';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private service: NotificationsService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((res: any) => {
        if (res instanceof HttpResponse && res.url?.includes(environment.backend)) {
          const body = res.body;

          if (
            body.resultMessage &&
            body.resultMessage.messageType === 'Error'
          ) {
            this.service.showError(body.resultMessage);
            return throwError(() => body.resultMessage);
          }

          if (body.totalPages != undefined) {
            return res;
          }

          return res.clone({ body: body.data || body.info || body });
        }
        return res;
      }),
      catchError((err) => {
        this.service.showError(err);
        return throwError(() => err);
      })
    );
  }
}
